module.exports = ".div-space {\r\n  padding-top: 20px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tryout/pages/tryout-members/partial/tryout-invite-members/tryout-invite-members.component.css
// module id = ./src/app/tryout/pages/tryout-members/partial/tryout-invite-members/tryout-invite-members.component.css
// module chunks = main